// extracted by mini-css-extract-plugin
export default {"container":"SeriesPage_container__BUNla"};